import { render, staticRenderFns } from "./details.vue?vue&type=template&id=43df0c2e&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style0 from "./details.vue?vue&type=style&index=0&id=43df0c2e&prod&scoped=true&lang=css"
import style1 from "./details.vue?vue&type=style&index=1&id=43df0c2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43df0c2e",
  null
  
)

export default component.exports